import React from 'react';
import AdditionalServicesSlider from './AdditionalServicesSlider';

const AdditionalServices = () => {
  return (
    <div className="bg-white overflow-hidden">
      <div className="container py-48  ">
        <div className="flex gap-[48px] flex-col ">
          <h2 className="flex justify-center items-center font-[600] text-[32px] md:text-[34px] leading-[39px] md:leading-[42px] text-black">
            Our Additional SEO Services
          </h2>
          <AdditionalServicesSlider />
        </div>
      </div>
    </div>
  );
};

export default AdditionalServices;
